import React from "react";
import { Box, Text, VStack } from "@chakra-ui/react";

interface ReadOnlySplitActionDisplayProps {
  status?: string;
  buyTimeMinutes?: string | number;
}

export const ReadOnlySplitActionDisplay: React.FC<ReadOnlySplitActionDisplayProps> = ({
  status,
  buyTimeMinutes,
}) => {
  if (!status) return null;

  if (status === "HOLD") {
    return (
      <Box
        w="70px"
        h="32px"
        borderRadius="full"
        border="1px solid"
        borderColor="yellow.500"
        bg="yellow.100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="default"
      >
        <Text
          fontSize="0.8rem"
          fontWeight="700"
          color="yellow.700"
          fontFamily="'Nunito','Inter', sans-serif"
        >
          HOLD
        </Text>
      </Box>
    );
  }

  if (status === "CANCELLED") {
    return (
      <Box
        px={3}
        h="32px"
        borderRadius="full"
        border="1px solid"
        borderColor="red.500"
        bg="red.50"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="default"
      >
        <Text
          fontSize="0.75rem"
          fontWeight="700"
          color="red.700"
          fontFamily="'Nunito','Inter', sans-serif"
        >
          CANCELLED
        </Text>
      </Box>
    );
  }

  if (status === "BUYTIME_TAKEN") {
    const minutes = parseInt(String(buyTimeMinutes || "0"));
    let hoursStr = "-";
    if (!isNaN(minutes) && minutes > 0) {
      const hours = minutes / 60;
      const roundedHours = Math.round(hours * 10) / 10;
      hoursStr = String(roundedHours);
    }

    return (
      <VStack spacing={0.5} align="center">
        <Box
          px={3}
          py={1}
          h="32px"
          borderRadius="full"
          border="1px solid"
          borderColor="blue.500"
          bg="blue.100"
          display="flex"
          alignItems="center"
          gap={2}
          cursor="default"
        >
          <Text
            fontSize="0.8rem"
            fontWeight="700"
            color="blue.700"
            fontFamily="'Nunito','Inter', sans-serif"
          >
            BUY TIME
          </Text>
          <Box
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            borderRadius="full"
            px={2.5}
            py={0.5}
            display="flex"
            alignItems="center"
            justifyContent="center"
            h="20px"
          >
            <Text
              fontSize="0.75rem"
              fontWeight="700"
              color="gray.600"
              fontFamily="'Nunito','Inter', sans-serif"
            >
              {hoursStr} hrs
            </Text>
          </Box>
        </Box>
      </VStack>
    );
  }

  if (status === "CONFIRMED") {
    return (
      <Box
        px={3}
        py={1}
        h="32px"
        borderRadius="full"
        border="1px solid"
        borderColor="green.500"
        bg="green.100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="default"
      >
        <Text
          fontSize="0.8rem"
          fontWeight="700"
          color="green.700"
          fontFamily="'Nunito','Inter', sans-serif"
        >
          CONFIRMED
        </Text>
      </Box>
    );
  }

  if (status === "ACTIVE") {
    return (
      <Box
        px={3}
        py={1}
        h="32px"
        borderRadius="full"
        border="1px solid"
        borderColor="gray.300"
        bg="gray.100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="default"
      >
        <Text
          fontSize="0.8rem"
          fontWeight="700"
          color="gray.600"
          fontFamily="'Nunito','Inter', sans-serif"
        >
          NO ACTION TAKEN
        </Text>
      </Box>
    );
  }

  return null;
};
